import { createFileRoute, redirect } from '@tanstack/react-router';

import { Landing } from '#features/landing/components/Landing';
import { landingPageQueryOptions } from '#features/landing/model/landing';
import { landingRouteHead, landingRouteLoader } from '#features/landing/utils/landingRoute';

const gameSlug = 'gta';
const SPLIT_INTO = 'gta-5';

export const Route = createFileRoute('/{-$locale}/_layout/_landing/gta')({
  loader: async ({ params: { locale }, context }) => {
    // GTA Online разъехалась на две игры, и её адрес стал /gta-5. Старый проиндексирован и
    // открыт на проде, поэтому уводим постоянным редиректом: только 301 переносит ссылки и
    // позиции. Новый лендинг проверяем первым на случай, если фронт выехал раньше config:
    // тогда справочник ещё не знает про gta-5, и живой адрес превратился бы в пустую страницу.
    const split = await context.queryClient
      .ensureQueryData(landingPageQueryOptions(SPLIT_INTO))
      .catch(() => null);

    if (split) {
      throw redirect({
        to: '/{-$locale}/gta-5',
        params: { locale },
        statusCode: 301,
        replace: true,
      });
    }

    return landingRouteLoader(context.queryClient, gameSlug);
  },
  component: () => <Landing gameSlug={gameSlug} />,
  head: ({ loaderData, params }) => landingRouteHead(gameSlug, loaderData, params.locale),
});
